import React, {useContext} from 'react';
import { styled, alpha } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import ArchiveIcon from '@mui/icons-material/Archive';
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import {ThemeContext} from "../../contexts/ThemeContext";
import { Link as RouterLink } from "react-router-dom";
import {homepage} from "../../config";
import {MainMenuOptions} from "./NavBar";

const Link = styled(RouterLink)(({ menuOptionsFontColor }) => ({
    textDecoration: "none",
    color: menuOptionsFontColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}));

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme, menuOptionsFontColor }) => ({
    '& .MuiPaper-root': {
        top: 67,
        right: 0,
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: menuOptionsFontColor,
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.primary.main,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));

export default function MenuNavBar() {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const { theme, toggleTheme } = useContext(ThemeContext);
    const menuOptionsFontColor = theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300]

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    return (
        <div>
            <IconButton
                id="demo-customized-button"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                sx={{
                    color: 'inherit',
                    padding: 0,
                    margin: 0,
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                }}
            >
                <MenuIcon sx={{ width: 40, height: 40 }} />
            </IconButton>
            <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MainMenuOptions isColumnMenu={true} handleClose={handleClose} />
                {/*<Divider sx={{ my: 0.5 }} />*/}
                {/*<MenuItem onClick={() => {toggleTheme();handleClose();}}>*/}
                {/*    {theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}*/}
                {/*    {theme.palette.mode === 'dark' ? 'light' : 'dark'}*/}
                {/*</MenuItem>*/}
            </StyledMenu>
        </div>
    );
}
